import { forwardRef, type Ref, type SVGProps } from "react";
const IconBeachFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27.3 27.276A3.46 3.46 0 0 1 25 28a3.48 3.48 0 0 1-2.293-.707A5.3 5.3 0 0 0 19 26a5.3 5.3 0 0 0-3.7 1.276A3.46 3.46 0 0 1 13 28a3.48 3.48 0 0 1-2.293-.707A5.3 5.3 0 0 0 7 26a5.3 5.3 0 0 0-3.707 1.293.99.99 0 0 0-.006 1.4 1.007 1.007 0 0 0 1.408.03A3.46 3.46 0 0 1 7 28a3.48 3.48 0 0 1 2.293.707A5.3 5.3 0 0 0 13 30a5.3 5.3 0 0 0 3.7-1.281A3.46 3.46 0 0 1 19 28a3.48 3.48 0 0 1 2.293.707A5.3 5.3 0 0 0 25 30a5.3 5.3 0 0 0 3.706-1.3.994.994 0 0 0 .006-1.4 1.006 1.006 0 0 0-1.412-.024" />
    <path d="M26.735 14.589a1.165 1.165 0 0 0 1.47-.741 1 1 0 0 0 .038-.147c.584-4.635-2.46-9.225-7.329-10.979l.011-.042a1 1 0 1 0-1.932-.518l-.01.039C13.865 1.251 8.9 3.705 7.077 8.03a1.163 1.163 0 0 0 .717 1.482 1 1 0 0 0 .145.04l8.466 2.269L13.946 21H10a2.916 2.916 0 0 0-3 2.829V24a.994.994 0 0 0 .987.993H8a1.007 1.007 0 0 0 1-.981A.917.917 0 0 1 9.813 23 1 1 0 0 1 10 23h16a1 1 0 0 0 0-2h-9.983l2.319-8.656Z" />
  </svg>
);
const ForwardRef = forwardRef(IconBeachFilledSVG);
ForwardRef.displayName = "IconBeachFilled";
export { ForwardRef as IconBeachFilled };
